export function fileToDataUrl(file: File) {
	// returns dataurl of a selected file
	return new Promise<string>((resolve, reject) => {
		const reader = new FileReader();
		reader.onload = () => {
			resolve(reader.result as string);
		};
		reader.onerror = reject;
		reader.readAsDataURL(file);
	});
}

export function resizeImage(imageDataURL: string) {
	return new Promise<string>((resolve, reject) => {
		const image = new Image();
		image.crossOrigin = 'Anonymous';
		image.src = imageDataURL;
		image.onload = () => {
			const canvas = document.createElement('canvas');
			const ctx = canvas.getContext('2d');

			const widthMultiplier = image.height > image.width ? image.width / image.height : 1;
			const heightMultiplier = image.width > image.height ? image.height / image.width : 1;

			canvas.width = 299 * widthMultiplier;
			canvas.height = 299 * heightMultiplier;

			if (ctx) {
				ctx.drawImage(image, 0, 0, canvas.width, canvas.height);
			}

			resolve(canvas.toDataURL('image/png', 0.75));
		};
		image.onerror = reject;
	});
}
